
    import Vue from "vue";
    import FileUploader from "@/components/FileUploader.vue";
    import Component from "vue-class-component";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import HeadingWave from "@/features/shared/components/HeadingWave.vue";
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import {
        AddSeafarerWithoutPersonalCodeModel,
        CountryLightModel,
        DocumentAttributesClient,
        factory,
        Gender,
        ResultError,
        SeafarersClient
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import Loader from "@/features/shared/components/Loader";
    import PopoverInfo from '@/components/PopoverInfo.vue';
    import {NavigationGuardNext} from "vue-router/types/router";
    import toasts from "@/components/Toasts";

    interface Props {
        countries: CountryLightModel[];
    }

    @Component({
        components: {
            SectionPageHeading,
            HeadingWave,
            FileUploader,
            HeadingGroup,
            PopoverInfo
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<AddSeafarerWithoutPersonalCode>) {
            const props = to.meta!.props as Props;
            Promise.all([
                new DocumentAttributesClient().countries()
            ]).then(values => {
                props.countries = values[0];
                next();
            }).catch(e => next(e))
        }
    })
    export default class AddSeafarerWithoutPersonalCode extends Vue implements Props {
        @Prop({required: true})
        countries!: CountryLightModel[];

        model = factory.create(AddSeafarerWithoutPersonalCodeModel);
        validationErrors = ResultError.createEmpty();
        loader = new Loader();

        created(){
            this.$watch(() => this.model.withoutNationality, () => {
                this.model.nationality = null;
            });
        }

        async addSeafarer(){
            this.validationErrors = ResultError.createEmpty();
            await new SeafarersClient().setLoader(this.loader).addWithoutPersonalCode(this.model)
                .then(result => {
                    toasts.success(this.$ls.Global_Toast_AddSuccess);
                    this.$router.push({name: "person-profile", params:{seafarerId: result.id}});
                })
                .catch(error => this.setValidationErrors(error, this.$ls.Global_Toast_FormAddFailure));
        }

        genderOptions = [
            {text: this.$ls.Global_Gender_Male, value: Gender.Male},
            {text: this.$ls.Global_Gender_Female, value: Gender.Female},
        ];
    }
